export enum MergeThirdPartyProviderName {
  SEVEN_SHIFTS = 'SEVEN_SHIFTS',
  ADP_WORKFORCE_NOW = 'ADP_WORKFORCE_NOW',
  ALEXISHR = 'ALEXISHR',
  ALTERA_PAYROLL = 'ALTERA_PAYROLL',
  AZURE_ACTIVE_DIRECTORY = 'AZURE_ACTIVE_DIRECTORY',
  BREATHE = 'BREATHE',
  CERIDIAN_DAYFORCE = 'CERIDIAN_DAYFORCE',
  CHARLIE = 'CHARLIE',
  DEEL = 'DEEL',
  FACTORIAL = 'FACTORIAL',
  FRESHTEAM = 'FRESHTEAM',
  GOOGLE_WORKSPACE = 'GOOGLE_WORKSPACE',
  GUSTO = 'GUSTO',
  HIBOB = 'HIBOB',
  HRALLIANCE = 'HRALLIANCE',
  HR_CLOUD = 'HR_CLOUD',
  HR_PARTNER = 'HR_PARTNER',
  HUMAANS = 'HUMAANS',
  INSPERITY_PREMIER = 'INSPERITY_PREMIER',
  INTELLIHR = 'INTELLIHR',
  JUMPCLOUD = 'JUMPCLOUD',
  JUSTWORKS = 'JUSTWORKS',
  KEKA = 'KEKA',
  LANO = 'LANO',
  LUCCA = 'LUCCA',
  NAMELY = 'NAMELY',
  NMBRS = 'NMBRS',
  OFFICIENT = 'OFFICIENT',
  OKTA = 'OKTA',
  ONELOGIN = 'ONELOGIN',
  OYSTERHR = 'OYSTERHR',
  PAYCAPTAIN = 'PAYCAPTAIN',
  PAYCHEX = 'PAYCHEX',
  PAYCOR = 'PAYCOR',
  PAYFIT = 'PAYFIT',
  PAYLOCITY = 'PAYLOCITY',
  PEOPLEHR = 'PEOPLEHR',
  PERSONIO = 'PERSONIO',
  PINGONE = 'PINGONE',
  PROLIANT = 'PROLIANT',
  SAGE_HR = 'SAGE_HR',
  SAP_SUCCESSFACTORS = 'SAP_SUCCESSFACTORS',
  SAPLING = 'SAPLING',
  SESAME = 'SESAME',
  SQUARE_PAYROLL = 'SQUARE_PAYROLL',
  TRINET = 'TRINET',
  UKG_DIMENSIONS = 'UKG_DIMENSIONS',
  UKG_PRO = 'UKG_PRO',
  UKG_READY = 'UKG_READY',
  ZENEFITS = 'ZENEFITS',
}

export interface IMergeLinkToken {
  linkToken: string;
}
